import React, { useContext, useRef, useEffect } from 'react';
import SubscriptionsContext from '../../context/subscriptions/subscriptionsContext';
const SubscriptionsFilter = () => {
  const subscriptionsContext = useContext(SubscriptionsContext);
  const { filterSubscriptions, clearFilter, filtered } = subscriptionsContext;
  const text = useRef('');

  useEffect(() => {
    if (filtered === null) {
      text.current.value = '';
    }
  });

  const onChange = e => {
    //debugger;
    if (text.current.value !== '') {
      filterSubscriptions(e.target.value);
    } else {
      clearFilter();
    }
  };

  return (
    <form>
      <input
        ref={text}
        type='text'
        placeholder='Filter Subscriptions'
        onChange={onChange}
      />
    </form>
  );
};

export default SubscriptionsFilter;
